import { Router, Route, Switch, RouteComponentProps } from 'react-router-dom';
import ConfigurationsList from '../pages/ConfigurationsList/ConfigurationsList';
import AuditTrailsList from '../pages/AuditTrailsList/AuditTrailsList';
import ConfigurationDetail from '../pages/ConfigurationDetail/ConfigurationDetail';
import { createBrowserHistory } from 'history';
import React from 'react';
import AppDrawer from '../components/AppDrawer/AppDrawer';
import PrivateRoute from './PrivateRoute';
import { CAN_CREATE } from '../shared/constants/AuthConstants';
import { AppHeader } from '../components/header/AppHeader';

export const appHistory = createBrowserHistory();

const AppRouter = () => {
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
    };

    const Refresh = ({ path = '/' }) => (
        // Workaround to enable route refresh based on https://github.com/ReactTraining/react-router/issues/4056
        <Route
            path={path}
            component={({ history }: RouteComponentProps) => {
                history.goBack();
                return null;
            }}
        />
    );

    return (
        <Router history={appHistory}>
            <AppHeader handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose} />
            <AppDrawer handleDrawerClose={handleDrawerClose} open={drawerOpen} />
            <Switch>
                <Refresh path="/refresh" />
                <Route path="/" exact component={ConfigurationsList} />
                <Route path="/edit-configuration/:configurationId" component={ConfigurationDetail} />
                <PrivateRoute
                    path="/add-configuration"
                    component={ConfigurationDetail}
                    authorizationNeeded={CAN_CREATE}
                />
                <PrivateRoute
                    path="/audit-trails/:configurationId"
                    component={AuditTrailsList}
                    authorizationNeeded={CAN_CREATE}
                />
                <PrivateRoute path="/audit-trails" component={AuditTrailsList} authorizationNeeded={CAN_CREATE} />
            </Switch>
        </Router>
    );
};

export default AppRouter;
